import React, { useState } from "react";
import StatusBar from "./StatusBar";
import Sidebar from "./Sidebar";
import HelpPanel from "./HelpPanel";

// Page content runs edge to edge; the bottom padding only clears the mobile tab bar.
const AppShell = ({ children, pageId = "dashboard", contentClassName = "" }) => {
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <div className="h-screen w-screen flex overflow-hidden bg-slate-100" data-testid="app-shell">
      <Sidebar />

      <div className="flex-1 min-w-0 min-h-0 flex flex-col">
        <StatusBar onOpenHelp={() => setHelpOpen(true)} />

        <main
          className={`flex-1 min-h-0 overflow-y-auto overflow-x-hidden flex flex-col pb-16 md:pb-0 ${contentClassName}`}
        >
          {children}
        </main>
      </div>

      <HelpPanel pageId={pageId} isOpen={helpOpen} onClose={() => setHelpOpen(false)} />
    </div>
  );
};

export default AppShell;
